/**
 * Section heading inside a drawer. 16px/600, matching the headings the
 * `*DrawerSection` components already render, so every heading in a drawer is
 * the same size. Spacing stays with the call site.
 */
function DrawerSectionHeading({ className = '', ...props }) {
    return (
        <div
            className={`flex flex-wrap text-base font-semibold ${className}`}
            {...props}
        />
    );
}

export default DrawerSectionHeading;
